export const USED_XOFILTEREDITOR = 'used XOFilterEditor';
export const CHANGED_ASSOCIATION = 'changed association';
export const USED_SEGMENTATION_FILTERS = 'used SegmentationFilters';
export const USED_FILTERS_BAR = 'used FiltersBar';
export const USED_LEGACY_FILTERS_BAR = 'used QuickFiltersBar (legacy)';